import Library            from "../utils/Library";
import SpriteResponsive   from "../responsive/SpriteResponsive";
import GraphicsResponsive from "../responsive/GraphicsResponsive";
import { gsap } from "gsap";

import * as PIXI from "pixi.js";

export default class BackgroundMultiplyResponsive extends PIXI.Container
{
    constructor(options)
    {
        super();

        this.scene = options.scene;
        this.xOffset = options.offset;
        this.rgbaBGTint = "rgba(255,255,255,1)";

        this.build();
    }

    changeScene (scene)
    {
        this.scene = scene;
    }

    set tintBG (value)
    {
        this.rgbaBGTint = value;

        //convert rgba to hex
        let hex = this.rgba2hex(value);

        this.backgroundColor.tint = hex;


    }

    get tintBG ()
    {
        return this.rgbaBGTint;
    }

    rgba2hex(orig, useAlpha = false)
    {
        var a, isPercent,
            rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
            alpha = (rgb && rgb[4] || "").trim(),
            hex = rgb ?
                  (rgb[1] | 1 << 8).toString(16).slice(1) +
                  (rgb[2] | 1 << 8).toString(16).slice(1) +
                  (rgb[3] | 1 << 8).toString(16).slice(1) : orig;


        if (useAlpha)
        {
            if (alpha !== "")
            {
                a = alpha;
            }
            else
            {
                a = 1;
            }
            // multiply before convert to HEX
            a = ((a * 255) | 1 << 8).toString(16).slice(1)


            hex = hex + a;
        }

        return hex;
    }

    hex2rgba(hex)
    {
        let bigint = parseInt(hex, 16);
        let r = (bigint >> 16) & 255;
        let g = (bigint >> 8) & 255;
        let b = bigint & 255;

        return "rgba(" + r + "," + g + "," + b + ",1)";
    }
    build ()
    {
        let bgTexture = Library.instance.getTexture(this.scene.background.key);

        this.bgTexture = bgTexture;

        let bgResponsive = this.convertToResponsive(this.scene.background);
        bgResponsive.params.x.gravity += this.xOffset;
        this.background = new SpriteResponsive(bgTexture, bgResponsive);
        this.backgroundColor = new GraphicsResponsive(bgResponsive);
        this.backgroundColor.beginFill(0xFFFFFF, 1);
        this.backgroundColor.drawRect(bgTexture.width / -2, 0, bgTexture.width, bgTexture.height);
        this.backgroundColor.endFill();

        this.bgRGB = {r: 255, g: 255, b: 255};

        // let sceneDefaultColor = parseInt("0x"  + this.scene.background.color.default.color ?? "000000");
        //
        // let arrSceneDefaultColorRGB = gsap.utils.splitColor(sceneDefaultColor);
        // let objSceneDefaultColorRGB = {r: arrSceneDefaultColorRGB[0], g: arrSceneDefaultColorRGB[1], b: arrSceneDefaultColorRGB[2]};
        //
        // gsap.to(this.bgRGB, {duration: 1, r: objSceneDefaultColorRGB.r, g: objSceneDefaultColorRGB.g, b: objSceneDefaultColorRGB.b, onUpdate: this.onUpdateBG.bind(this)});

        this.changeEmotion("default")

        this.addChild(this.background);
        this.addChild(this.backgroundColor);

        this.backgroundColor.blendMode = PIXI.BLEND_MODES.MULTIPLY;
    }

    changeEmotion (emotion)
    {
        if (!this.scene.background.color[emotion])
        {
            emotion = "default";
        }

        let sceneColor = parseInt("0x"  + this.scene.background.color[emotion].color ?? "000000");

        let arrSceneColorRGB = gsap.utils.splitColor(sceneColor);
        let objSceneColorRGB = {r: arrSceneColorRGB[0], g: arrSceneColorRGB[1], b: arrSceneColorRGB[2]};

        gsap.to(this.bgRGB, {duration: 4, r: objSceneColorRGB.r, g: objSceneColorRGB.g, b: objSceneColorRGB.b, onUpdate: this.onUpdateBG.bind(this)});
    }
    onUpdateBG ()
    {
        let r = parseInt(this.bgRGB.r).toString(16).padStart(2, "0");
        let g = parseInt(this.bgRGB.g).toString(16).padStart(2, "0");
        let b = parseInt(this.bgRGB.b).toString(16).padStart(2, "0");

        let color = "0x" + r + g + b;

        this.backgroundColor.tint = parseInt(color);
    }


    convertToResponsive (data)
    {
        return {
            params:
                {
                    x: {gravity: data.gravity.x, using: "width"},
                    y: { gravity: data.gravity.y, using: "height"}
                },

            scale: data.scale,
            anchor: data.anchor
        }
    }

    layout ()
    {
        if (this.background)
        {
            this.background.layout();
            this.backgroundColor.layout();
        }
    }
}
